import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
//API
import { BranchOfficeFetchAPI } from '../../../api/BranchOffices';
import { UsersFetchAPI } from '../../../api/Users';
import { OrdersFetchAPI } from '../../../api/Orders';
import { ExcelModuleFechtAPI } from '../../../api/ExcelModule';
// External Componets
import moment from 'moment-timezone';
import Select from 'react-select';
//Internal components 
import ReportTable from '../table/ReportTable';
import CardTotals from '../cards/CardTotals';
import SuccessAlert from '../../Alerts/SuccessAlert';
import LoadingAlert from '../../Alerts/LoadingAlert';
import ErrorAlert from '../../Alerts/ErrorAlert';
//External components 
import Button from 'react-bootstrap/Button';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { EventsFetchAPI } from '../../../api/Events';
pdfMake.vfs = pdfFonts.pdfMake.vfs


const GeneralReport = ({ setSelectedEventOption, selectedEventOption, events, setEvents, setSelectedWaiterOption, selectedWaiterOption, selectedUserOption, setSelectedUserOption, waiters, setWaiters, cashiers, setCashiers, selectedBranch, selectedBranches }) => {
    //Params
    let { business_code } = useParams();
    const selectedBranchCodes = selectedBranches?.length > 0
        ? selectedBranches.map(b => b.code)
        : [];
    //We get the user data 
    let user = JSON.parse(localStorage.getItem('user'))
    let token = localStorage.getItem('x-access-token');
    //States 
    const [userBranchoffices, setUserBranchs] = useState([]);
    const [userBusiness, setUserBusiness] = useState({
        id: 0
    });
    const [initialDate, setInitialDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T00:00:00.000+00:00');
    const [maxDate, setMaxDate] = useState(moment(new Date()).tz('America/Bogota').format('YYYY-MM-DD') + 'T23:59:59.000+00:00')
    //States of search select 
    const [machineCase, setMachineCase] = useState(false);
    const [vendingCase, setVendingCase] = useState(false);
    const [waiterCase, setWaiterCase] = useState(false);
    const [url, setUrl] = useState(null);

    const [data, setReportData] = useState({
        totalTaxSales: 0,
        subTotalSales: 0,
        totalSales: 0,
        totalDiscounts: 0,
        totalDevolutions: 0,
        totalDeliveryFee: 0,
        business: '',
        user: '',
        waiter: {
            name: ''
        },
        machines: [],
        paymenthods: [],
        createdAt: '',
        branchofficeDate_orders: [],
        orders: []
    });

    //Functio to get cashier users depending of the branch selected
    const getCashiers = async () => {
        let response;
        try {
            if (selectedBranches?.length === 1) {
                response = await UsersFetchAPI.getUsersByBranchofficesAndRole([selectedBranches[0].branchoffice_id || selectedBranches[0].id], [4, 21], token);
            } else {
                response = await UsersFetchAPI.getUsersByBusinessAndRole(userBusiness.id, [4, 21], token);
            }
            setCashiers(response.data.users);
        } catch (err) {
            setCashiers([]);
        }
    };

    //Function to get waiters users depending of the branch selected
    const getWaiters = async () => {
        let response;
        try {
            if (selectedBranches?.length === 1) {
                response = await UsersFetchAPI.getUsersByRoleAndBranchoffice(selectedBranches[0].branchoffice_id || selectedBranches[0].id, 15, token);
            } else {
                response = await UsersFetchAPI.getUsersByBusinessAndRole(userBusiness.id, [15], token);
            }
            setWaiters(response.data.users);
        } catch (err) {
            setWaiters([]);
        }
    };

    //Function to get events depending of the branch selected
    const getEvents = async () => {
        let response;
        try {
            if (selectedBranches?.length === 1) {
                response = await EventsFetchAPI.getEventsByBranchoffice(selectedBranches[0].branchoffice_id || selectedBranches[0].id, token);
            } else {
                response = await EventsFetchAPI.getEventsByBusiness(userBusiness.id, token);
            }
            setEvents(response.data.events);
        } catch (err) {
            setEvents([]);
        }
    };


    //The default option of the select input 
    const defaultOption = [{ label: 'Seleccione...', value: 0 }, { label: 'Terminales de autoservicio', value: 1 }, { label: 'Vending', value: 'v' }];

    //Get users (cashiers)
    const usersList = cashiers.map((user) => ({
        label: user.user_name + ' ' + user.lastName + ': ' + user.idCard,
        value: user.user_id
    }));
    const waitersList = waiters.map((user) => ({
        label: user.user_name + ' ' + user.lastName + ': ' + user.idCard,
        value: user.user_id
    }));

    const eventsList = events.map((event) => ({
        label: event.name,
        value: event?.id ?? event.event_id
    }));

    //Function to get the report of the branch office 
    const getReport = async (dateMin, dateMax) => {
        let response;
        let event = selectedEventOption !== null && selectedEventOption.value !== 0 && selectedEventOption.value !== undefined ? selectedEventOption.value : undefined;
        try {
            //We show a loading alert 
            LoadingAlert();
            //We check if the machine case is true (on the select input we select the machine option)
            if (machineCase === true) {
                //We get the transaction info with the machine selected
                response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyMachines(business_code, selectedBranch.code, dateMin, dateMax, 0, user.id, 0, token, undefined, undefined, event, selectedBranchCodes);
            } else if (machineCase === false && vendingCase === true) {
                //We get the transaction info with the machine selected
                response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyMachines(business_code, selectedBranch.code, dateMin, dateMax, 0, user.id, 'v', token, undefined, undefined, event, selectedBranchCodes);
            }
            else {
                //We get the transactions depending of the user selected
                if (waiterCase === false && (selectedUserOption === null || selectedUserOption.value === 0 || selectedUserOption.value === undefined)) {                    //We get the transaction general info with the admin user logged 
                    response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(business_code, selectedBranch.code, dateMin, dateMax, 0, user.id, token, undefined, undefined, undefined, undefined, undefined, undefined, event, selectedBranchCodes);

                } else if (waiterCase && (selectedWaiterOption !== null && selectedWaiterOption.value !== 0 && selectedWaiterOption.value !== undefined)) {
                    //We get the transaction info with the waiter selected
                    response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(business_code, selectedBranch.code, dateMin, dateMax, 0, user.id, token, undefined, undefined, undefined, undefined, undefined, selectedWaiterOption.value, event, selectedBranchCodes);
                }
                else {
                    //We get the transaction info with the user selected
                    response = await OrdersFetchAPI.getTransactionsByBranchOfficePaymentMethodbyUser(business_code, selectedBranch.code, dateMin, dateMax, 0, selectedUserOption.value, token, undefined, undefined, undefined, true, undefined, undefined, event, selectedBranchCodes);
                }
            }
            //We set the info 
            setReportData({
                totalTaxSales: response.data.analitics.totalTaxSales,
                subTotalSales: response.data.analitics.subTotalSales,
                totalSales: response.data.analitics.totalSales,
                totalDiscounts: response.data.analitics.totalDiscounts,
                totalDeliveryFee: response.data.analitics.totalDeliveryFee,
                business: response.data.analitics.business,
                branchoffice: response.data.analitics.branchoffice,
                machines: response.data.analitics.machines,
                paymenthods: response.data.analitics.paymenthods,
                createdAt: response.data.analitics.createdAt,
                branchofficeDate_orders: response.data.analitics.branchofficeDate_orders,
                totalDevolutions: response.data.analitics.totalDevolutions,
                user: response.data.analitics.user_selected,
                waiter: response.data.analitics.waiter,
                orders: response.data.orders
            });

            //We show a success alert
            SuccessAlert();
        } catch (err) {
            //We show a error alert 
            ErrorAlert('No tiene información')
            console.log(err)
        }
    }

    //Event to detect the user selected on search select 
    const handleChangeUsers = (option) => {
        //We check if the option is null 
        if (option.value === 0) {
            setSelectedUserOption(null);
            setMachineCase(false);
            setVendingCase(false);
            setWaiterCase(false);
            setSelectedWaiterOption(null);
        } else if (option.value === 1) {
            setMachineCase(true);
            setVendingCase(false);
            setSelectedUserOption(option);
            setWaiterCase(false);
            setSelectedWaiterOption(null);

        } else if (option.value === 'v') {
            setMachineCase(false);
            setVendingCase(true);
            setSelectedUserOption(option);
            setWaiterCase(false);
            setSelectedWaiterOption(null);
        }
        else {
            setSelectedUserOption(option);
            setMachineCase(false);
            setVendingCase(false);
            setWaiterCase(true);
            setSelectedWaiterOption(null);

        }
    };

    //Event to detect the waiter selected on search select
    const handleChangeWaiters = (option) => {
        //We check if the option is null
        if (option.value === 0) {
            setWaiterCase(false);
            setSelectedWaiterOption(null);
            setSelectedUserOption(null);
            setMachineCase(false);
            setVendingCase(false);
        } else {
            setWaiterCase(true);
            setSelectedWaiterOption(option);
            setSelectedUserOption(null);
            setMachineCase(false);
            setVendingCase(false);
        }
    }
    //Event to detect the event selected on search select
    const handleChangeEvents = (option) => {
        //We check if the option is null
        if (option.value === 0) {
            setSelectedEventOption(null);
        } else {
            setSelectedEventOption(option);
        }
    }

    //Function to populate the orders details by createdAt date 
    const tableBranchOfficeOrders = () => {
        let branchOfficeOrdersData = data.branchofficeDate_orders;
        let rows = [];
        //We construc the table 
        for (let i = 0; i < branchOfficeOrdersData.length; i++) {
            let branchOfficeOrdersData_info = branchOfficeOrdersData[i];
            {/* Encabezado de la tabla de Productos  */ }
            rows.push(
                // ?Title Of Table
                {
                    text: 'Fecha de las ordenes: ' + branchOfficeOrdersData_info.branchOfficeDate,
                    style: 'subheaderRight',
                },
                {
                    style: 'tableExample',
                    table: {
                        widths: [140, '*', 150],
                        headerRows: 1,
                        // dontBreakRows: true,
                        // keepWithHeaderRows: 1,
                        body: [
                            //Values of Reports 
                            [
                                //Tables Headers 
                                {
                                    text: 'N°.Orden',
                                    style: 'tableHeader',
                                    border: [false, false, false, false],
                                },
                                {
                                    text: 'Método de Pago',
                                    style: 'tableHeader',
                                    border: [false, false, false, false],
                                },
                                {
                                    text: 'Total',
                                    style: 'tableHeader',
                                    border: [false, false, false, false],
                                }
                            ],
                        ]
                    }, layout: 'lightHorizontalLines'
                },
            );
            //We get the final row position to get the table of the orders 
            let final_row_position = rows.length;
            //We construct the rows of the table 
            for (let j = 0; j < branchOfficeOrdersData_info.orders.length; j++) {
                let order = branchOfficeOrdersData_info.orders[j];
                let data_row = [
                    //Column 1
                    {
                        border: [false, false, false, true],
                        fillColor: '#eeffee',
                        text: 'Orden:# ' + order.transaction_code,
                    },

                    //Column 2
                    {
                        border: [false, false, false, true],
                        fillColor: '#eeffee',
                        text: order.devolution_order_reference !== undefined ? 'Devolución de ' + order.paymenthod + ' de la orden #' + order.devolution_order_reference.code : order.paymenthod,
                    },

                    //Column 3
                    {
                        border: [false, false, false, true],
                        fillColor: '#eeffee',
                        text: ' $ ' + order.total.toFixed(2),
                    },

                ]
                {/* Filas de la tabla completa de ordenes */ }
                rows[final_row_position - 1].table.body.push(data_row);
            }
        }
        return rows

    }


    //Function to populate the payment methods table rows 
    const tablePaymentMethods = () => {
        let paymentMethodsData = data.paymenthods
        //We construct the rows 
        let rows = [];
        //We populate the payment methods 
        for (let i = 0; i < paymentMethodsData.length; i++) {
            let paymenmethod = paymentMethodsData[i];
            let payment_row = [
                //Column 1
                paymenmethod.name,
                //Column 2
                ' $ ' + paymenmethod.total.toFixed(2)
            ]

            rows.push(payment_row)
        }

        let table = {
            style: 'tableExample',
            table: {
                widths: [200, '*'],

                headerRows: 1,
                // dontBreakRows: true,
                // keepWithHeaderRows: 1,
                body: [
                    [

                        //Tables Headers 
                        { text: 'Formas de Pago', style: 'tableHeader2' },
                        { text: 'Total', style: 'tableHeader2' }],
                    ...rows
                ]
            }, layout: 'lightHorizontalLines'
        }
        //We return the table 
        return table

    }

    //We create the pdf 
    const createPdf = () => {
        let machines = []
        let date = ''
        let hour = ''

        //validationof fields
        if (data.length !== 0) {
            machines = data.machines.join(', ');
            date = data.createdAt.split('T')[0];
            hour = data.createdAt.split('T')[1];
        }
        //Information
        let name_bussiness = data.business
        //When several branches are selected the backend can't report back a single branchoffice,
        //so we build the list from what the user actually picked instead of data.branchoffice
        let name_branch = selectedBranches?.length > 1
            ? selectedBranches.map(branch => branch.branchoffice_name || branch.name).join(', ')
            : data.branchoffice


        const docDefinition = {

            pageSize: 'A4',
            pageMargins: [23, 10, 23, 5],

            content: [
                //?IMG
                {
                    "image": "logo-smartpay",
                    width: 100,
                },
                //?Title Report 
                {
                    stack: [
                        'Reportes de Ventas',
                    ],
                    style: 'header'
                },

                //Information Bussiness
                //? 1 --------------------------
                {
                    text: [
                        { text: 'Empresa:', style: 'subheader' },
                        name_bussiness
                    ], margin: [0, 20, 0, 5]
                },
                //? 2 --------------------------       
                {
                    text: [
                        {
                            text: name_branch !== '' ? 'Sucursal:' : '',
                            style: 'subheader'
                        },
                        name_branch !== '' ? name_branch : '',
                    ], margin: [0, 0, 0, 5]
                },
                //? 3 --------------------------
                {
                    text: [
                        {
                            text: data.user.name !== '' ? 'Cajera/o : ' + data.user.name : '',
                            style: 'subheader'
                        },
                    ], margin: [0, 0, 0, 5]
                },
                {
                    text: [
                        {
                            text: selectedEventOption !== null && selectedEventOption.value !== 0 && selectedEventOption.value !== undefined ? 'Evento: ' + selectedEventOption.label : '',
                            style: 'subheader'
                        },
                    ],
                    margin: [0, 0, 0, 5]
                },
                //? 5 --------------------------
                {
                    text: [
                        {
                            text: data?.waiter !== undefined && data.waiter.name !== undefined ? 'Mesero/a : ' + data.waiter.name : '',
                            style: 'subheader'
                        },
                    ], margin: [0, 0, 0, 5]
                },

                // {
                //     text: data.user.name !== '' ? 'Cajera/o : ' + data.user.name : '',
                //     style: 'subheader'
                // },
                //? 4 --------------------------
                {
                    text: [
                        {
                            text: 'Máquinas:',
                            style: 'subheader',
                        },
                        machines
                    ], margin: [0, 0, 0, 5]
                },

                //? 5 --------------------------           
                {
                    text: [
                        {
                            text: 'Fecha:',
                            style: 'subheader',
                            margin: [0, 0, 0, 10]
                        },
                        date
                    ], margin: [0, 0, 0, 5]
                },

                //? 6 --------------------------
                {
                    text: [
                        {
                            text: 'Hora: ',
                            style: 'subheader',
                            margin: [0, 0, 0, 20]
                        },
                        hour
                    ]
                },


                //?Title Of Table
                {
                    text: 'Ordenes',
                    style: 'titles', margin: [0, 15, 0, 0]
                },
                //Title Of Table
                tableBranchOfficeOrders(),

                //Title Of Table
                {
                    text: 'Métodos de Pago',
                    style: 'titles'
                },


                //Pays methods Table of Contents
                tablePaymentMethods(),

                //Title Of Table
                {
                    text: 'Montos totales',
                    style: 'titles'
                },


                //Totals 
                {
                    style: 'tableExample',
                    table: {
                        widths: [200, '*'],
                        headerRows: 1,
                        // dontBreakRows: true,
                        // keepWithHeaderRows: 1,
                        body: [
                            [

                                //Tables Headers 
                                { text: 'Montos', style: 'tableHeader3' },
                                { text: 'Total', style: 'tableHeader3' }],

                            //Values of Reports 
                            [
                                //Column 1
                                'Subtotal: ',
                                //Column 2
                                ' $ ' + data.subTotalSales.toFixed(2),
                            ],

                            [
                                //Column 1
                                "Total por envios:",
                                //Column 2
                                ' $ ' + data.totalDeliveryFee.toFixed(2),
                            ],

                            [
                                //Column 1
                                'Impuestos: ',
                                //Column 2
                                ' $ ' + data.totalTaxSales.toFixed(2),
                            ],

                            [
                                //Column 1
                                'Total de ventas : ',
                                //Column 2
                                ' $ ' + data.totalSales.toFixed(2),
                            ],
                        ]
                    }, layout: 'lightHorizontalLines'
                },


                //Title Of Table
                {
                    text: 'Información adicional',
                    style: 'titles'
                },


                //Adicional info 
                {
                    style: 'tableExample',
                    table: {
                        widths: [200, '*'],
                        headerRows: 1,
                        // dontBreakRows: true,
                        // keepWithHeaderRows: 1,
                        body: [
                            [

                                //Tables Headers 
                                { text: 'Dato', style: 'tableHeader3' },
                                { text: 'Total', style: 'tableHeader3' }],


                            //Values of Reports 
                            [
                                //Column 1
                                'Devoluciones totales realizadas: ',
                                //Column 2
                                ' $ ' + data.totalDevolutions.toFixed(2),
                            ],
                            //Values of Reports 
                            [
                                //Column 1
                                'Descuentos totales: ',
                                //Column 2
                                ' $ ' + data.totalDiscounts.toFixed(2),
                            ],
                        ]
                    }, layout: 'lightHorizontalLines'
                },

            ],

            images: {
                "logo-smartpay": "https://res.cloudinary.com/dk3x6ubyi/image/upload/v1682698324/hi2vihfdtgg98ybwbxnn.png"
            },

            styles: {
                header: {
                    fontSize: 16,
                    bold: true,
                    alignment: 'center',
                    margin: [0, 5, 0, 10],
                },
                titles: {
                    fontSize: 14,
                    bold: true,
                    alignment: 'center',
                },
                subheader: {
                    fontSize: 12,
                    bold: true,
                    alignment: 'left',
                },
                subheaderRight: {
                    fontSize: 12,
                    alignment: 'right',
                    color: '#A8A8A8'
                },
                tableExample: {
                    margin: [0, 5, 0, 15]
                },
                tableHeader: {
                    fillColor: '#43CD3B',
                    fontSize: 13,
                    color: 'white',
                    bold: true,
                },

                tableHeader2: {
                    fillColor: '#26BABF',
                    fontSize: 13,
                    color: 'white',
                    bold: true,
                },

                tableHeader3: {
                    fillColor: '#266DBF',
                    fontSize: 13,
                    color: 'white',
                    bold: true,
                }


            }

        }


        const pdfGenerator = pdfMake.createPdf(docDefinition);
        pdfGenerator.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            setUrl(url)

        })

        pdfGenerator.download();
    }


    //Function to download the general sales report in excel
    const downloadGeneralSalesReport = async (initialDate, maxDate, selectedBranchId, machineId, userBusinessId, userId, event_id) => {
        let error = false;
        try {
            await ExcelModuleFechtAPI.downloadGeneralSalesReport(token, initialDate, maxDate, selectedBranchId, machineId, userBusinessId, userId, event_id);
        } catch (err) {
            error = true;
        }
        //We show a error alert
        if (error) {
            ErrorAlert('No se pudo descargar el reporte', 'Error de descarga', 'error');
        }
    }



    //Hook to load the initial data 
    useEffect(() => {
        //We set the branchoffices of the user 
        setUserBranchs(user.branchoffices);
        //We set the business user 
        setUserBusiness(user.business);
    }, []);

    //Hook to load the users depending the selection of branch
    useEffect(() => {
        //The selection state (selectedUserOption/selectedWaiterOption) is reset to null by the parent
        //whenever the branch changes, so these local case flags must be reset in lockstep or getReport
        //ends up reading .value off a stale null option
        setMachineCase(false);
        setVendingCase(false);
        setWaiterCase(false);

        if (userBusiness?.id) {
            getCashiers();
            getWaiters();
            getEvents();
        }
    }, [selectedBranches, userBusiness]);


    return (
        <div className='mx-lg-2 mx-1'>
            <h4 className='fw-bold text-primary mt-2'>Filtros</h4>
            <div className="row gx-3 gy-2 align-items-center bg-white p-2 border-sp border">
                <div className="col-6 col-md-6 col-lg-3">
                    <div className="form-group">
                        <label htmlFor="input_from" className='fw-bold'>Desde</label>
                        <input type="date" name="initialDate" onChange={e => setInitialDate(e.target.value + "T00:00:00.000+00:00")} className="form-control" />
                    </div>
                </div>
                <div className="col-6 col-md-6 col-lg-3">
                    <div className="form-group">
                        <label htmlFor="input_from" className='fw-bold'>Hasta</label>
                        <input type="date" name="finishDate" onChange={e => setMaxDate(e.target.value + "T23:59:59.000+00:00")} className="form-control" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-3">
                    <label htmlFor="input_from" className='fw-bold' >Cajeros (opcional)</label>
                    <Select
                        className='w-100'
                        value={selectedUserOption}
                        options={[defaultOption[0], defaultOption[1], defaultOption[2], ...usersList]}
                        onChange={handleChangeUsers}
                    />

                </div>
                <div className="col-sm-12 col-md-6 col-lg-3">
                    <label htmlFor="input_from" className='fw-bold' >Meseros (opcional)</label>
                    <Select
                        className='w-100'
                        value={selectedWaiterOption}
                        options={[defaultOption[0], ...waitersList]}
                        onChange={handleChangeWaiters}
                    />
                </div>
                <div className="col-sm-12 col-md-6 col-lg-3">
                    <label htmlFor="input_form" className="fw-bold">Eventos (opcional)</label>
                    <Select
                        className='w-100'
                        value={selectedEventOption}
                        options={[defaultOption[0], ...eventsList]}
                        onChange={handleChangeEvents}
                    />
                </div>
                <div className=" d-flex justify-content-center justify-content-sm-end mb-3">
                    <button type="button" onClick={e => getReport(initialDate, maxDate)} className="btn btn-success px-5">Aceptar</button>
                </div>
            </div>

            <div className="d-lg-flex justify-content-lg-between d-none mt-3">
                <h4 className="fw-bold text-primary">Reporte de Ventas General Total </h4>
                <div className="d-flex justify-content-between mt-3 mb-2 gap-2">
                    <button onClick={() => downloadGeneralSalesReport(initialDate, maxDate, selectedBranch.id, vendingCase === true ? 'v' : machineCase, userBusiness.id, data.user.id, selectedEventOption !== null && selectedEventOption.value !== 0 && selectedEventOption.value !== undefined ? selectedEventOption.value : null)}
                        className="btn btn-outline-success">
                        <i className="fa-solid fa-file-excel me-2"></i>
                        Descargar Excel
                    </button>
                    <button className='btn btn-outline-danger' onClick={createPdf}>
                        <i className="fa-solid fa-file-pdf me-2"></i>
                        <span >Descargar PDF</span>
                    </button>
                </div>
            </div>


            {/**Totales de ventas */}
            <CardTotals
                total_sales={data.totalSales}
                total_itbms={data.totalTaxSales}
                total_discounts={data.totalDiscounts} />

            {/**Table */}
            <ReportTable
                table_name="Tabla de ventas detalladas"
                table_headers={["Fecha", "Hora", "Orden", "Total con propina", "Propina", "Total contable", "Itbms", "Envio", "Subtotal", "Descuento", "cufe"]}
                table_type="general_report"
                table_data={data.orders}
            />
        </div>



    );
}

export default GeneralReport;